// React imports.
import React from "react";


// App imports.
import Assessment3aMainTableRow from "./Assessment3aMainTableRow";

const Assessment3aMainTable = ({ state, step, holder, fieldChangeHandler }) => (
    <div>
    
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel</div>
            <div className="header">Total # of Assisted Households</div>
            {step.showVendorAssignedEntry === true &&
                <div className="header"># of Households Assigned to an Electric Vendor</div>
            }
            {step.showVendorAssignedStatus === true &&
                <React.Fragment>
                    <div className="header">% of HHs Assigned to an Electric Vendor</div>
                    <div className="header">Status</div>
                </React.Fragment>
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Electric.name)
                &&
                <Assessment3aMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Electric.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Electric} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.NaturalGas.name)
                &&
                <Assessment3aMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.NaturalGas.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.NaturalGas} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.FuelOil.name)
                &&
                <Assessment3aMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.FuelOil.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.FuelOil} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Propane.name)
                &&
                <Assessment3aMainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Propane.name )}fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Propane} />
            }
        </div>
    </div>
);

export default Assessment3aMainTable;
